import { useEffect, useState } from "react";
import {
  onIdTokenChanged,
  signInWithPopup,
  signOut as fbSignOut,
} from "firebase/auth";
import { collection, getDocs, query, where, limit } from "firebase/firestore";
import { auth, googleProvider, db } from "./firebase";
import { CLIENTS_COLLECTION } from "./portalConfig";

export function useAuth() {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [client, setClient] = useState(null); // doc de la allowlist si tiene acceso
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onIdTokenChanged(auth, async (u) => {
      if (!u) {
        setUser(null);
        setIsAdmin(false);
        setClient(null);
        setLoading(false);
        return;
      }

      const token = await u.getIdTokenResult();
      setUser(u);
      setIsAdmin(token.claims.admin === true);

      // resolver acceso de cliente desde la allowlist (colección "clients")
      let record = null;
      try {
        const email = (u.email || "").toLowerCase();
        if (email) {
          const snap = await getDocs(
            query(
              collection(db, CLIENTS_COLLECTION),
              where("email", "==", email),
              limit(1)
            )
          );
          if (!snap.empty) {
            const d = snap.docs[0];
            const data = d.data();
            if (data.active !== false) record = { id: d.id, ...data };
          }
        }
      } catch {
        /* sin acceso de cliente o reglas restringidas */
      }
      setClient(record);
      setLoading(false);
    });
    return unsub;
  }, []);

  async function signInWithGoogle() {
    await signInWithPopup(auth, googleProvider);
  }

  async function signOut() {
    await fbSignOut(auth);
  }

  return {
    user,
    isAdmin,
    isClient: !!client,
    client,
    loading,
    signInWithGoogle,
    signOut,
  };
}
